import TableRemoveButton from "./TableRemoveButton";
export default TableRemoveButton;